import ModalSendPDFDraft from './ModalSendPDFDraft-redux';

export default ModalSendPDFDraft;
